import React, { Component } from 'react';
import { DescriptionMatch, subMenu, getIdFocusable, handleFocusAutoScroll } from './index';
import { Menu } from './Menu';
import { RouteComponentProps } from 'react-router-dom';
import './styles/vcardMatch.scss';
import { autobind } from 'packages/core/lib';
import Device from 'src/devices/device';
import Utils from 'src/utils/Utils';
import LayersControl from 'src/utils/LayersControl';

interface IVcardMatchProps {
    history: RouteComponentProps | any;
    location: string | any;
}

class VcardMatch extends Component<IVcardMatchProps> {
    keys: any;
    state: { currentKey: null | string; idMatch: null | string };

    constructor(props: IVcardMatchProps) {
        super(props);
        this.keys = (Device.getDevice() && Device.getDevice().getKeys()) || null;
        this.state = { currentKey: null, idMatch: null };
    }

    @autobind
    private focusOnLocation(location: string): void {
        const splitLocation = location.split('/');
        const href = splitLocation[splitLocation.length - 1];
        const id = getIdFocusable(`/${href}`);
        const element = document.getElementById(id);
        if (element) {
            element.focus();
            handleFocusAutoScroll(500);
        }
    }

    @autobind
    private handleBack() {
      if(LayersControl.isPlayerVisible()) {
          document.getElementById('image-play') && Utils.setInitialFocus('#play-focusable');
          const btn = document.getElementById('play-focusable');
          if(btn) {
              btn.removeAttribute('tabIndex');
          }
          return;
      }
      const { history } = this.props;
      history.goBack();

  }
    @autobind
    private handleKeyPress(e: any): void {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        this.setState({ currentKey });
        if (currentKey === 'BACK') {
            this.handleBack();
        }
    }
    @autobind
    private addEventListener() {
        document.removeEventListener('keydown', this.handleKeyPress, true);
        document.addEventListener('keydown', this.handleKeyPress, true);
    }

    @autobind
    private removeEventListener() {
        document.removeEventListener('keydown', this.handleKeyPress, true);
    }

    componentDidMount() {
        const splitLocation = location.pathname.split('/');
        const idMatch =
            splitLocation && splitLocation.length === 4
                ? splitLocation[splitLocation.length - 1]
                : null;
        this.setState({ idMatch });
        this.addEventListener();
    }

    componentWillUnmount() {
        this.removeEventListener();
    }

    componentDidUpdate(): void {
        const { currentKey } = this.state;

        if (currentKey === 'BACK') {
            this.focusOnLocation(location.pathname);
        } else if (currentKey === null) {
            Utils.setInitialFocusChangeTime('.selected', 0);
            handleFocusAutoScroll(500);
        }
    }

    public render(): JSX.Element {
        const { history, location } = this.props;
        const { idMatch } = this.state;
        return (
            <div>
                <DescriptionMatch history={history} location={location} />
                <Menu options={subMenu} history={history} idMatch={idMatch} />
            </div>
        );
    }
}

export default VcardMatch;



// WEBPACK FOOTER //
// ./src/mundial/Vcards/VcardMatch/VcardMatch.tsx